var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.route.length > 0),expression:"route.length > 0"}],staticClass:"card",class:{
    'border-light-grey shadow fade-in mb-4': _vm.onScreen,
    'border-grey mb-0': !_vm.onScreen
  }},[_c('div',{staticClass:"card-header text-center py-1",class:{
      'text-light has-background-sapn': _vm.onScreen,
      'border-bottom-grey': !_vm.onScreen
    }},[_vm._v(" Route Map ")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"mx-auto",class:{
        'printed-map-dimensions': !_vm.onScreen
      },attrs:{"id":_vm.mapId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }